import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { getAllPromocodes } from "../actions/promocodeActions";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Pagination from "../components/Pagination";
import "../css/records.css";

const PromoCodeScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [pageCount, setPageCount] = useState(0);

  const getPromocode = useSelector((state) => state.getPromocode);

  const { promocode } = getPromocode;

  useEffect(() => {
    setSearchParams({ page }, { replace: true });
  }, [page]);

  useEffect(() => {
    dispatch(getAllPromocodes(page));
  }, [dispatch, page]);

  useEffect(() => {
    setPageCount(getPromocode?.pagination?.pageCount || 0);
  }, [getPromocode]);

  const adminInfo = useSelector((state) => state.adminInfo);

  const { adminData } = adminInfo;

  const handleClick = () => {
    // Get current IST date
    const currentDateIST = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );
    const currentMonthIST = currentDateIST.getMonth();
    const currentYearIST = currentDateIST.getFullYear();

    // Filter promo codes created by this admin in the current IST month
    const createdCount = promocode.filter((promo) => {
      const promoDateIST = new Date(
        new Date(promo.createdAt).toLocaleString("en-US", {
          timeZone: "Asia/Kolkata",
        })
      );
      return (
        promo.createdBy === adminData.name &&
        promoDateIST.getMonth() === currentMonthIST &&
        promoDateIST.getFullYear() === currentYearIST &&
        promo.applicableProducts?.length === 1
      );
    }).length;

    // Check limit
    // if (createdCount >= 8) {
    //   alert("You have reached your maximum limit for this month.");
    // } else
    //    {
      navigate("/promocode/create");
    // }
  };

  const [code, setCode] = useState("");

  const [promocodeCreated, setPromocodeCreated] = useState(false);
  const [error, setError] = useState("");

  const promocodeSubmit = async (e) => {
    e.preventDefault();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const now = new Date();
    const lastDay = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
    let expirationDate = lastDay.toISOString();
    try {
      const response = await axios.post(
        "https://d2c-storefront.emotorad.com/api/promocode/admin",
        {
          discountCode: code,
          discountType: "amount",
          discountValue: 0,
          expirationDate: expirationDate,
          usageLimit: 1000,
          usageCount: 0,
          minOrderValue: 0,
          applicableProducts: [
            "63fef7af38ced178e34e5b0a",
            "63fefa0938ced178e34e5b0b",
            "66123f08886d1a984d1b5015",
            "671a36355ca134bab1f04d2f",
            "6544a7d5897107b23599ba8f",
            "658d75ae05a371a821407b4e",
            "66f2be4a4015fd82191dbbe4",
            "6793903deb4a15d6185be91e",
            "68653121c1e99424312667c9",
          ],
          status: "active",
          createdBy: adminData.name,
        },
        config
      );

      if (response) {
        setError("");
        setPromocodeCreated(true);
      }
    } catch (error) {
      setError("Duplicate Entry");
    }
  };

  return (
    <>
      <div
        class="modal fade"
        id="trackingModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog  modal-dialog-centered">
          <form className="modal-content" onSubmit={promocodeSubmit}>
            <div class="">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Add Promocode details
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="">
                  <label className="mb-2">Enter Code</label>
                  <input
                    type="text"
                    required
                    pattern="^0{1,2}1[A-Z0-9]*$"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    class="form-control"
                  />
                  <small className="text-muted">
                    only capitalized alphanumeric characters starting with 01 or
                    001*
                  </small>
                  <br></br>
                  {promocodeCreated ? (
                    <small className="text-success">Created Successfully</small>
                  ) : (
                    <>
                      <small className="text-danger">{error}</small>
                    </>
                  )}
                </div>
              </div>
              <div class="modal-footer">
                {promocodeCreated ? (
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setCode("");
                      setError("");
                      setPromocodeCreated(false);
                    }}
                  >
                    Close
                  </button>
                ) : (
                  <button type="submit" class="btn btn-primary">
                    Save changes
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="container-fluid ps-0 ">
        <div className="row ">
          <div className="col-lg-2">
            <Sidebar active={4} />
          </div>
          <div
            className="col-lg-10 p-0"
            style={{
              overflowY: "scroll",
              height: "100vh",
            }}
          >
            <div className="records-page">
              <div className="records-header-row d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="records-heading">Promocodes</h4>
                <div className="d-flex" style={{ gap: "0.75em" }}>
                  {promocode && (
                    <button
                      className="btn btn-success text-light records-action-btn"
                      onClick={handleClick}
                    >
                      <i className="fa-solid fa-plus"></i> Create BDC
                      Promocode
                    </button>
                  )}
                  {promocode && (
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#trackingModal"
                      onClick={() => {
                        setCode("");
                        setError("");
                        setPromocodeCreated(false);
                      }}
                      className="btn btn-warning text-light records-action-btn"
                    >
                      <i className="fa-solid fa-plus"></i> Influencer
                      Promocode
                    </button>
                  )}
                </div>
              </div>

              <div className="records-status-bar">
                <Pagination page={page} pageCount={pageCount} onChange={setPage} />
                <div className="stat-pills">
                  <span className="stat-pill total">
                    <span className="stat-dot"></span>Total{" "}
                    <span className="stat-value">
                      {getPromocode?.pagination?.count ?? "--"}
                    </span>
                  </span>
                </div>
              </div>

              <div className="table-card">
                <table className="records-table">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Code</th>
                      <th>Value</th>
                      <th>Usage Count</th>
                      <th>Usage Limit</th>
                      <th>Status</th>
                      <th>Created By</th>
                      <th>Created Date &amp; Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {promocode &&
                      promocode.map((item, i) => (
                        <tr key={item._id || i}>
                          <td>{(page - 1) * 20 + i + 1}</td>
                          <td>{item.discountCode}</td>
                          <td>{item.discountValue}</td>
                          <td>{item.usageCount}</td>
                          <td>{item.usageLimit}</td>
                          <td>
                            <span
                              className={`status-badge ${
                                item.status === "active" ? "active" : "draft"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>
                          <td>{item.createdBy}</td>
                          <td className="cell-nowrap">
                            {item.createdAt
                              ? new Date(item.createdAt).toLocaleString(
                                  "en-IN",
                                  {
                                    timeZone: "Asia/Kolkata",
                                  }
                                )
                              : ""}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromoCodeScreen;
